import React, { useRef, useState } from 'react';
import { Sidebar } from 'src/reuseableComponents';
import SingleUpload from 'src/reuseableComponents/singleUpload.component';

function CustomSingleFileUploader({
  open,
  handleClose,
  bucket,
  path,
  func,
  accept,
  title,
  subtitle,
}) {
  const childRef = useRef();
  const [value, setValue] = useState('');

  const handleDrawerSubmit = () => {
    const value = childRef.current.handleOk();
    if (func) {
      func(value);
    }
    onClose();
  };

  const onImageSelect = imageName => {
    setValue(imageName);
  };

  const onClose = () => {
    setValue('');
    handleClose();
  };

  return (
    <Sidebar
      open={open}
      onClose={onClose}
      title={title || 'Catalogue Images'}
      subtitle={subtitle || 'Add catalogue images here.'}
      primaryButtonText="ADD RESOURCE"
      primaryButtonAction={handleDrawerSubmit}
      primaryButtonDisabled={!value}
      secondaryButtonText="EXIT MENU"
      secondaryButtonAction={onClose}
      secondaryButtonDisabled={false}
    >
      <SingleUpload
        bucket={bucket}
        path={path}
        ref={childRef}
        accept={accept}
        onImageSelect={onImageSelect}
      />
    </Sidebar>
  );
}

export { CustomSingleFileUploader };
